import { useTranslation } from 'react-i18next';
import { Navigate, useLocation, useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { InventoryItemEditionFormWrapper } from 'src/Components/Forms/Inventory/InventoryItemEditionFormWrapper';

type InventoryItemParams = {
  assetId: string;
  itemId: string;
};

const EditInventoryItemDrawer = () => {
  const { t } = useTranslation();
  const { assetId, itemId } = useParams<InventoryItemParams>();
  const location = useLocation();
  const listPath = location.pathname.includes('/inventories/exited/')
    ? `/asset/${assetId}/inventories/exited`
    : `/asset/${assetId}/inventories`;

  if (!itemId) {
    return <Navigate to={listPath} replace />;
  }

  return (
    <AnimatedRoutedDrawer title={t('inventory.edit.title', 'Modifier l’objet')} to={listPath}>
      {({ onClose }) => <InventoryItemEditionFormWrapper itemId={itemId} onClose={onClose} />}
    </AnimatedRoutedDrawer>
  );
};

export default EditInventoryItemDrawer;
